import { Injectable } from '@angular/core';
import { NfcChecker } from 'nfc-checker';

@Injectable({ providedIn: 'root' })
export class NfcService {
    async getNfcStatus(): Promise<{ supported: boolean; enabled: boolean }> {
        const result = await NfcChecker.isNfcAvailable();
        return result;
    }
}
